var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 21.4336C25.8898 19.9207 27.75 17.0929 27.75 13.8542C27.75 9.02168 23.6086 5.10417 18.5 5.10417C13.3914 5.10417 9.25 9.02168 9.25 13.8542C9.25 17.0929 11.1102 19.9207 13.875 21.4336M23.125 21.4336H13.875M23.125 21.4336V25.5208M13.875 21.4336V25.5208M23.125 25.5208V26.9792C23.125 28.59 21.7445 29.8958 20.0417 29.8958H16.9583C15.2555 29.8958 13.875 28.59 13.875 26.9792V25.5208M23.125 25.5208H13.875",
    stroke: "#1254CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.625 13.8542H3.08333M6.9375 5.83333L5.39583 4.375M6.9375 21.1458L5.39583 22.6042",
    stroke: "#1254CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6045 13.8542H33.1462M29.292 5.83333L30.8337 4.375M29.292 21.1458L30.8337 22.6042",
    stroke: "#1254CC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOn);
export default __webpack_public_path__ + "static/media/LightOn.b13d35b3.svg";
export { ForwardRef as ReactComponent };